export default "__VITE_ASSET__BQ5Ma1wS__"